import Vue from 'vue'
import UserService from '../service/user.service';
import tenantService from "@/service/tenant.service";

const RolesPlugin = {
  install(/* vue */) {
    Vue.mixin({
      computed: {
        $isLoggedIn() {
          return UserService.loggedIn;
        },
        $userInfo() {
          return UserService.getUserInfo();
        },
        $isAdmin() {
          return this.$hasMatchingRoles(['admin']);
        },
        $isBasicUser() {
          return this.$hasMatchingRoles(['basic']);
        },
        $isAgentUser() {
          return this.$hasMatchingRoles(['agent']);
        },
        $isHousingManager() {
          return this.$hasMatchingTenantRoles(['tenant_housing_manager']);
        },
        $isHousingCoordinator() {
          return this.$hasMatchingTenantRoles(['tenant_housing_coordinator']);
        },
        $isChairman() {
          return this.$hasMatchingTenantRoles(['tenant_chairman']);
        },
      },
      methods: {
        $clearUserInfo() {
          UserService.clearUserInfo();
        },
        $hasMatchingRoles(roles) {
          const userInfo = UserService.getUserInfo();
          if (userInfo == null) {
            return false;
          }
          const userRoles = userInfo.roles;
          const matchingRoles = roles.findIndex(role => {
            if (userRoles.length > 0) {
              return userRoles.findIndex(r => r.toLowerCase() === role.toLowerCase()) > -1;
            }
          });
          return matchingRoles > -1;
        },
        $hasMatchingTenantRoles(roles) {
          const userInfo = UserService.getUserInfo();
          if (userInfo == null) {
            return false;
          }

          const savedTenant = tenantService.tenant;

          const tenantIndex = userInfo.tenantRoles.findIndex(tenant => tenant.tenant === savedTenant);
          if (tenantIndex > -1) {
            const userRoles = userInfo.tenantRoles[tenantIndex].roleSet;
            const matchingRoles = roles.findIndex(role => {
              if (userRoles.length > 0) {
                return userRoles.findIndex(r => r.toLowerCase() === role.toLowerCase()) > -1;
              }
            });
            return matchingRoles > -1;
          }
          return false;
        },
      }
    });
  },
};

export default RolesPlugin;
